import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { FileRejection } from 'react-dropzone/.';
import { DisabledWhenPolicyExceeded } from '../../../containers/DisabledWhenPolicyExceeded';
import { IImageFile } from '../imagesUpload.service';
import { IRejectedFile } from '../models/IRejectedFile';
import { ImagesDropZone } from './ImagesDropZone';

interface IProps {
  datasetId: string;
  isProcessingImages: boolean;
  imagesToUploadFromFile: IImageFile[];
  imagesRejectedFromFile: IRejectedFile[];
  addImagesToDataset(images: File[], fileRejections: FileRejection[]): Promise<void>;
}

export const ImageUploader = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <DisabledWhenPolicyExceeded limitType='space'>
      <ImagesDropZone
        acceptedFileTypes={{ 'image/jpeg': ['.jpg', '.jpeg'], 'image/png': ['.png'], 'image/bmp': ['.bmp'] }}
        acceptedFiles={props.imagesToUploadFromFile.map((i) => i.file)}
        rejectedFiles={props.imagesRejectedFromFile}
        isProcessingImages={props.isProcessingImages}
        onFilesDrop={(images, fileRejections) => {
          void props.addImagesToDataset(images, fileRejections);
        }}
      >
        <FontAwesomeIcon icon={faUpload} />
        {t('drop_your_files')}
      </ImagesDropZone>
    </DisabledWhenPolicyExceeded>
  );
});
